module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8512/img/blobsRight.png"